//This is the file store 'variable'
export const API_URL = `https://forkify-api.herokuapp.com/api/v2/recipes/`;
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 8;
export const KEY = 'f16299c7-58e1-4d8b-97b0-d2f1fe69c7fd';
export const SUBMIT_FORM_SEC = 1;
